export default "__VITE_ASSET__BIuMaFzT__"